import { isEntity } from '../utils';
import { Entity } from '@backstage/catalog-model';

export interface NautilusEntity extends Entity {
  spec: NautilusEntitySpec;
  metadata: Entity['metadata'] & {
    title: string;
    description: string;
  };
}

type NautilusEntitySpec = Entity['spec'] & {
  type?: string;
  teamMembers?: Array<{
    name: string;
    email: string;
  }>;
  capabilities?: Array<string>;
  valueStatement?: string;
  orderingProcess: string;
  support: string | number;
  nautilusOwner?: string;
  chargingModel?: string;
};

export function isNautilusEntity(entity: unknown): entity is NautilusEntity {
  return (
    isEntity(entity) &&
    isNautilusEntitySpec(entity) &&
    (entity.metadata.name?.length ?? 0) > 0 &&
    (entity.spec?.type == 'NautilusProductOwner' ||
      entity.spec?.type == 'NautilusProduct' ||
      entity.spec?.type == 'NautilusDomain' ||
      entity.spec?.type == 'NautilusDomainArea' ||
      entity.spec?.type == 'NautilusSegment')
  );
}

function isNautilusEntitySpec(spec: unknown): spec is NautilusEntitySpec {
  return typeof spec === 'object';
}
